import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import CountryStateCitySelector from "../../Lib/CountryStateCitySelector";
import useForm from "../../Hooks/customeractivationHook";
import { useContext, useState } from "react";
import { AuthContext } from "../../Context/AuthContext";
import axios from "axios";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { useCustomerFormContext } from "../../Context/CustomerFormContext";
import { toast, ToastContainer } from "react-toastify";
import { useQueryClient } from "react-query";
import "./Customeractive.css";

const Customeractivepage2 = () => {
  const { handleChange, handleSubmit, loading, formData, error, success } =
    useForm();
  const { formDatas } = useCustomerFormContext();
  const [saving, setSaving] = useState(false);
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const { logout, token } = useContext(AuthContext);

  // Function to handle save and logout
  const handleSaveLogout = async () => {
    setSaving(true);
    try {
      const requestData = {
        companyName: formDatas.companyName,
        registrationNumber: formDatas.registrationNumber,
        address: formData.address,
        state: formData.state,
        city: formData.city,
        country: formData.country,
        phoneNumber: formDatas.phoneNumber,
        additionalPhoneNumber: formDatas.additionalPhoneNumber,
        yearsInOperation: parseInt(formDatas.yearsInOperation),
        fundingSource: formDatas.fundingSource,
        website: formDatas.website,
        isProfileVerified: true,
        profileComplete: true,
        createdProfileStepStatus: { status: "completed" }
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/charterer/profile`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        // Invalidate profile query to refresh profile data
        queryClient.invalidateQueries(["profile"]);
        // Add a small delay to ensure profile verification is processed
        setTimeout(() => {
          logout();
          toast.success("Profile saved successfully. You are logged out!");
        }, 1000);
      }
    } catch (error) {
      console.error(error.message);
      toast.error("Error saving profile data!");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Fragment>
      <ToastContainer />
      <div className="customer-active-container">
        <div className="wrap">
          <div className="header">
            <button onClick={() => navigate("/Customeractivationpage1")}>
              Back
            </button>
            <BlackVatugIcon onClick={() => navigate("/")} />
            <button
              className="finished"
              onClick={handleSaveLogout}
              disabled={saving}
            >
              {saving ? "Saving & Log out" : "Save & Log out"}
            </button>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <h2>Customer Information</h2>
          <p>
            Please enter the name as it appears on a government-issued
            certificate or Bank Statement
          </p>

         
          <CountryStateCitySelector
            formData={formData}
            handleInputChange={handleChange}
            disableCountrySelection={true}
          />

          <label>
            Address
            <textarea
              placeholder="Enter address"
              name="address"
              value={formData.address}
              onChange={handleChange}
            ></textarea>
          </label>

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Finish"}
          </button>
          {error && <p style={{ margin: "auto", color: "red" }}>{error}</p>}
          {success && (
            <p style={{ margin: "auto", color: "green" }}>{success}</p>
          )}
        </form>
      </div>
    </Fragment>
  );
};

export default Customeractivepage2;
